import { YammerState } from '@ms/yammer-data/dist/state/types';
import { TypedUseSelectorHook, useSelector as useUntypedSelector } from 'react-redux';

export const useSelector: TypedUseSelectorHook<YammerState> = useUntypedSelector;
